import { render, staticRenderFns } from "./ProjectAnnounce.vue?vue&type=template&id=1baefe4e&scoped=true"
import script from "./ProjectAnnounce.vue?vue&type=script&lang=js"
export * from "./ProjectAnnounce.vue?vue&type=script&lang=js"
import style0 from "./ProjectAnnounce.vue?vue&type=style&index=0&id=1baefe4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baefe4e",
  null
  
)

export default component.exports